angular
  .module('qkr.inventory')
  .factory('inventoryService', (
    $http,
    appConfig,
    $q,
    utils,
    imageService,
    variantService
  ) =>
    {
      const getCategoryCommand = function(category) {
        const categoryCommand = {};

        // Translate from selected category Id to the object
        if (!utils.hasNoValue(category.id)) {
          categoryCommand.id = category.id;
        }
        categoryCommand.name = category.name;

        return categoryCommand;
      };

      let productCategoryList = [];
      let productList = [];

      const convertProductToInventoryItemCommand = function(
        product,
        outlet,
        variantRemovalList,
        variantDetailRemovalList
      ) {
        const inventoryItemCommand = {};

        if (product.id) {
          inventoryItemCommand.productId = product.id;
        }

        if (outlet != null) {
          inventoryItemCommand.outletId = outlet.id;
        }

        inventoryItemCommand.name = product.name;
        inventoryItemCommand.shortDescription = product.shortDescription;
        inventoryItemCommand.longDescription = product.longDescription;
        inventoryItemCommand.ledgerAnalysis = product.ledgerAnalysis;
        inventoryItemCommand.currency = product.currency;
        inventoryItemCommand.imageUrl = imageService.stripQueryString(
          product.fullImageUrl
        );
        inventoryItemCommand.categoryCommand = getCategoryCommand(
          product.category
        );
        inventoryItemCommand.amountMinorUnits = product.amountMinorUnits;
        inventoryItemCommand.sku = product.sku;
        inventoryItemCommand.stockTrackingEnabled = product.stockTrackingEnabled;
        inventoryItemCommand.taxRates = product.taxRates;
        inventoryItemCommand.prodNote = product.prodNote;

        if (
          inventoryItemCommand.stockTrackingEnabled &&
            product.stockQuantity != null
        ) {
          inventoryItemCommand.stockQuantityDelta = product.stockQuantity -
            (product.currentStockQuantity != null
              ? product.currentStockQuantity
              : 0);
        }

        if (product.salesTax != null) {
          const salesTaxCommand = {};
          salesTaxCommand.id = product.salesTax.id;
          inventoryItemCommand.salesTax = salesTaxCommand;
        }

        inventoryItemCommand.allowPurchaseNote = product.allowPurchaseNote;
        inventoryItemCommand.purchaseNoteMandatory = product.purchaseNoteMandatory;
        inventoryItemCommand.purchaseNoteLabel = product.purchaseNoteLabel;
        inventoryItemCommand.ageRestrictionEnabled = product.options.ageRestrictionEnabled;

        if (inventoryItemCommand.ageRestrictionEnabled) {
          if (!utils.hasNoValue(product.ageRestricted)) {
            inventoryItemCommand.allowedAge = product.ageRestricted;
          }
        }

        inventoryItemCommand.optionSets = product.optionSets;

        if (variantRemovalList != null && variantRemovalList.length > 0) {
          inventoryItemCommand.variantRemovalList = [];
          angular.forEach(variantRemovalList, variantId => {
            inventoryItemCommand.variantRemovalList.push({ id: variantId });
          });
        }

        if (
          variantDetailRemovalList != null &&
            variantDetailRemovalList.length > 0
        ) {
          inventoryItemCommand.variantDetailRemovalList = [];
          angular.forEach(variantDetailRemovalList, variantLabel => {
            inventoryItemCommand.variantDetailRemovalList.push({
              value: variantLabel
            });
          });
        }

        if (
          product.variants != null && !utils.hasNoValue(product.variants) &&
            product.variants.length > 0
        ) {
          if (!variantService.productHasSystemDefaultVariant(product)) {
            inventoryItemCommand.variantDefinitions = [];
            angular.forEach(product.variants, variant => {
              inventoryItemCommand.variantDefinitions.push(
                convertVariantToVariantDefinitionCommand(
                  variant,
                  outlet,
                  inventoryItemCommand.stockTrackingEnabled
                )
              );
            });
          }
        }

        return inventoryItemCommand;
      };

      var convertVariantToVariantDefinitionCommand = function(
        variant,
        outlet,
        stockTrackingEnabled
      ) {
        if (variant.variantId == null) {
          delete variant.variantId;
        }

        if (variant.sku == null) {
          delete variant.sku;
        }

        if (outlet != null) {
          variant.outletId = outlet.id;
        }

        if (
          utils.hasNoValue(variant.mediaLinks) ||
            utils.isEmpty(variant.mediaLinks)
        ) {
          delete variant.mediaLinks;
        }

        if (stockTrackingEnabled) {
          variant.stockQuantityDelta = variant.stockQuantity -
            (variant.currentStockQuantity != null
              ? variant.currentStockQuantity
              : 0);
        }

        delete variant.currentStockQuantity;
        delete variant.stockQuantity;

        angular.forEach(variant.variantDetails, variantDetail => {
          if (variantDetail.id == null) {
            delete variantDetail.id;
          }
        });

        return variant;
      };

      const setMinMaxPriceVariantsOnProduct = function(product) {
        const variantPriceArray = [];
        let minVariantPrice = 0;
        let maxVariantPrice = 0;

        if (product.variants != null && product.variants.length > 0) {
          minVariantPrice = product.variants[0].amountMinorUnits;
          maxVariantPrice = 0;

          angular.forEach(product.variants, variant => {
            variantPriceArray.push(parseInt(variant.amountMinorUnits));
            if (variant.amountMinorUnits < minVariantPrice) {
              minVariantPrice = variant.amountMinorUnits;
            }
            if (variant.amountMinorUnits > maxVariantPrice) {
              maxVariantPrice = variant.amountMinorUnits;
            }
          });
        } else {
          minVariantPrice = product.amountMinorUnits;
          maxVariantPrice = product.amountMinorUnits;
        }

        product.priceRange = minVariantPrice + ' - ' + maxVariantPrice;
        product.minimumVariantPrice = minVariantPrice;
        product.maximumVariantPrice = maxVariantPrice;
      };

      return {
        productList,
        productCategoryList,
        invalidateCache() {
          this.productList = [];
          this.productCategoryList = [];
        },
        fixImageUrls() {
          angular.forEach(this.productList, prod => {
            prod.fullImageUrl = imageService.fullImageUrl(prod.imageUrl);
          });
        },
        loadInventoryItem(id) {
          const self = this;
          const urlBase = appConfig.apiUrl;

          return $http
            .get(urlBase + 'inventoryItem/get/' + id, { withCredentials: true })
            .then(response => {
              const prod = response.data;
              self.trimSystemGeneratedSkus(prod);
              prod.fullImageUrl = imageService.fullImageUrl(prod.imageUrl);
              const prodList = [];
              prodList.push(prod);
              self.setMinMaxPriceVariants(prodList);
              return prod;
            });
        },
        trimSystemGeneratedSkus(prod) {
          if (!prod.manualSku) {
            prod.sku = '';
          }

          angular.forEach(prod.variants, variant => {
            if (!variant.manualSku) {
              variant.sku = '';
            }
          });
        },
        getCategoriesforSelectedVariants(selectedVariants, outletId) {
          const searchInventoryItemCommand = {
            selectedVariants,
            value: outletId
          };
          return $http
            .post(
              appConfig.apiUrl +
                'inventoryItem/getCategoriesforSelectedVariants',
              searchInventoryItemCommand,
              { withCredentials: true }
            )
            .then(response => response);
        },
        getProductsForSelectedCategories(categoryIds, outletId) {
          const searchInventoryItemCommand = {
            categoryIds,
            outletId: { value: outletId }
          };
          return $http
            .post(
              appConfig.apiUrl +
                'inventoryItem/getInventoryItemsForSelectedCategories',
              searchInventoryItemCommand,
              { withCredentials: true }
            )
            .then(response => response);
        },
        loadInventory(includeDeleted) {
          // List of minimal inventory items (just name, image, variant prices)
          const includeDeletedProduct = typeof includeDeleted !== 'undefined' &&
            includeDeleted === true;
          const self = this;
          const urlBase = appConfig.apiUrl;

          return $http
            .get(
              urlBase + 'inventoryItem/listMinimal?includeDeletedProduct=' +
                includeDeletedProduct,
              { withCredentials: true }
            )
            .then(response => {
              self.productList = response.data;
              self.fixImageUrls();
              self.setMinMaxPriceVariants(self.productList);
              return self.productList;
            });
        },
        loadInventoryFull() {
          // This is SLOW!!
          const self = this;
          if (utils.hasNoValue(self.productList)) {
            const urlBase = appConfig.apiUrl;

            return $http
              .get(urlBase + 'inventoryItem/list', { withCredentials: true })
              .then(response => {
                self.productList = response.data;
                self.fixImageUrls();
                self.setMinMaxPriceVariants(self.productList);
                return self.productList;
              });
          } else {
            const deferred = $q.defer();
            deferred.resolve(self.productList);
            return deferred.promise;
          }
        },
        loadProductCategoriesForInventory() {
          return $http
            .get(appConfig.apiUrl + 'productCategory/list', {
              withCredentials: true
            })
            .then(response => {
              self.productCategoryList = response.data;
              return self.productCategoryList;
            });
        },
        loadProductCategoriesForDeletedInventory() {
          return $http
            .get(appConfig.apiUrl + 'productCategory/listDeleted', {
              withCredentials: true
            })
            .then(response => response.data);
        },
        findInventoryItemInMenus(itemId) {
          const self = this;
          return $http
            .get(
              appConfig.apiUrl + 'inventoryItem/' + itemId + '/getMenuItems',
              { withCredentials: true }
            )
            .then(response => {
              self.productCategoryList = response.data;

              return self.productCategoryList;
            });
        },
        createProduct(product, outlet) {
          const createInventoryItemCommand = convertProductToInventoryItemCommand(
            product,
            outlet,
            null,
            null
          );
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/createWithVariants',
            createInventoryItemCommand
          );
        },
        updateProduct(
          product,
          outlet,
          removeVariantList,
          removeVariantDetailList
        ) {
          const updateInventoryItemCommand = convertProductToInventoryItemCommand(
            product,
            outlet,
            removeVariantList,
            removeVariantDetailList
          );
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/update',
            updateInventoryItemCommand
          );
        },
        removeProduct(product) {
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/delete',
            { id: product.id },
            { withCredentials: true }
          );
        },
        trashProduct(product) {
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/trash',
            { id: product.id },
            { withCredentials: true }
          );
        },
        restoreProduct(product) {
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/unDelete',
            { id: product.id },
            { withCredentials: true }
          );
        },
        hideProduct(product) {
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/hide',
            { id: product.id },
            { withCredentials: true }
          );
        },
        unhideProduct(product) {
          return $http.post(
            appConfig.apiUrl + 'inventoryItem/unhide',
            { id: product.id },
            { withCredentials: true }
          );
        },
        loadOptionSets() {
          return $http
            .get(appConfig.apiUrl + 'optionSet/list', { withCredentials: true })
            .then(response => response.data);
        },
        saveOptionSet(optionSet) {
          return $http
            .post(appConfig.apiUrl + 'optionSet/create', optionSet, {
              withCredentials: true
            })
            .then(response => response.data);
        },
        updateOptionSet(optionSet) {
          return $http
            .post(appConfig.apiUrl + 'optionSet/update', optionSet, {
              withCredentials: true
            })
            .then(response => response.data);
        },
        findMenuItemsUsingOptionSet(id) {
          return $http
            .get(appConfig.apiUrl + 'optionSet/' + id + '/menuItems', {
              withCredentials: true
            })
            .then(response => response.data);
        },
        deleteOptionSet(id) {
          return $http
            .post(appConfig.apiUrl + 'optionSet/delete', { id }, {
              withCredentials: true
            })
            .then(response => response.data);
        },
        updateAccTypes(items) {
          const updates = [];
          for (let i = 0; i < items.length; ++i) {
            updates.push({ id: items[i].id, accType: items[i].accType });
          }
          items.length = 0;

          const cases21Command = { updates };

          return $http
            .post(appConfig.apiUrl + 'cases21/updateAccTypes', cases21Command, {
              withCredentials: true
            })
            .then(response => {
              self.productList = response;
            });
        },
        saveAccountancyChanges(items) {
          const updatedItems = [];
          for (let i = 0; i < items.length; ++i) {
            updatedItems.push({
              inventoryItemId: items[i].id,
              accGlCode: items[i].accGlCode,
              accLedgerCode: items[i].accLedgerCode,
              accAccountNumber: items[i].accAccountNumber,
              accSubProgram: items[i].accSubProgram,
              accBudgetCentre: items[i].accBudgetCentre
            });
          }
          const cases21Command = { otcValues: updatedItems };
          return $http.post(
            appConfig.apiUrl + 'cases21/updateOverTheCounterCodes',
            cases21Command
          );
        },
        resetToUnCategorized(item) {
          return $http.get(
            appConfig.apiUrl + 'cases21/' + item.id + '/uncategorize'
          );
        },
        setMinMaxPriceVariants(products) {
          angular.forEach(products, product => {
            setMinMaxPriceVariantsOnProduct(product);
          });
        },
        setMinMaxPriceVariantsOnProduct(product) {
          setMinMaxPriceVariantsOnProduct(product);
        },
        getStockLevelsForProductInCurrentOutlet(product) {
          return $http.get(
            appConfig.apiUrl + 'inventoryItem/' + product.id +
              '/getStockLevelsForProductInCurrentOutlet'
          );
        },
        updateVariantStockLevel(variant, outletId, stockLevelQuantity) {
          const updateStockLevelCommand = {
            variantId: variant.id,
            outletId,
            quantityAvailable: parseInt(stockLevelQuantity)
          };
          return $http.post(
            appConfig.apiUrl + 'productVariant/updateStockLevel',
            updateStockLevelCommand
          );
        },
        /**
         * QKRD-4200 - We are enabling stock level tracking for certain non-school merchants.
         *             This is going to be done by updating the DB column in PROD so we are going to check if
         *             it has been set here to allow the merchant set a stock level if we have enabled it
         *             for them. This can't be done on the merchant level as each outlet will have a separate
         *             amount of each product so if on the merchant level we won't show anything.
         * */
        isStockLevelTrackingEnabled(isOutletLevel, productList) {
          if (productList.length === 0 || !isOutletLevel) {
            return false;
          }

          let product = {};

          for (let i = 0; i < productList.length; i++) {
            product = productList[i];

            if (product.stockTrackingEnabled === true) {
              return true;
            }
          }

          return false;
        }
      };
    });



// WEBPACK FOOTER //
// ./src/inventory/services/inventory.services.js